import { Routes, RouterModule } from '@angular/router';
import { ControllersComponent } from './controllers.component';
import { AuthGuard } from '@homeleite/arch';
import { AdminGuard } from '../../core/guards/admin.guard';

const BASE_PATH = 'controller';
const routes: Routes = [
  { path: BASE_PATH, redirectTo: `${BASE_PATH}/`, pathMatch: 'full' },
  {
    path: `${BASE_PATH}/:id`,
    component: ControllersComponent,
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Home Leite - Controladores' },
  },
];

export const ControllersRoutes = RouterModule.forChild(routes);
